import { compareProjectUpdatedAt } from './project-list';

export class ProjectRevisionLedger {
  private readonly floors = new Map<string, string>();

  floor(projectId: string) {
    return this.floors.get(projectId);
  }

  accepts(projectId: string, updatedAt: string) {
    const floor = this.floors.get(projectId);
    return floor === undefined || compareProjectUpdatedAt(updatedAt, floor) >= 0;
  }

  advance(projectId: string, updatedAt: string) {
    if (!this.accepts(projectId, updatedAt)) return false;
    const floor = this.floors.get(projectId);
    if (floor === undefined || compareProjectUpdatedAt(updatedAt, floor) > 0) {
      this.floors.set(projectId, updatedAt);
      return true;
    }
    return false;
  }

  remove(projectId: string) {
    this.floors.delete(projectId);
  }

  clear() {
    this.floors.clear();
  }
}

export type ChildProjectRequestScope = Readonly<{
  identityEpoch: number;
  projectId: string;
  projectUpdatedAt: string;
  projectInstance: object;
}>;

export function createChildProjectRequestScope(
  identityEpoch: number,
  projectId: string,
  projectUpdatedAt: string,
  projectInstance: object,
): ChildProjectRequestScope {
  return Object.freeze({ identityEpoch, projectId, projectUpdatedAt, projectInstance });
}

export function isChildProjectRequestScopeCurrent(
  scope: ChildProjectRequestScope,
  current: Readonly<{
    identityEpoch: number;
    routeProjectId?: string;
    project?: Readonly<{ id: string; updatedAt: string }>;
  }>,
) {
  return scope.identityEpoch === current.identityEpoch
    && scope.projectId === current.routeProjectId
    && scope.projectId === current.project?.id
    && scope.projectUpdatedAt === current.project.updatedAt
    && scope.projectInstance === current.project;
}
